const INITIAL_STATE = {
  discounts: [],
  loading: false,
  errorMessage: undefined
};

const automaticDiscountsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "FETCH_START_DISCOUNTS":
      return {
        ...state,
        loading: true
      };
    case "FETCH_SUCCESS_DISCOUNTS":
      return {
        ...state,
        loading: false
      };
    case "GET_DISCOUNTS":
      return {
        ...state,
        discounts: action.payload,
        loading: false
      };
    case "GET_DISCOUNTS_FRONT":
      return {
        ...state,
        discounts: action.payload,
        loading: false
      };
    case "FETCH_FAILURE_DISCOUNTS":
      return {
        ...state,
        errorMessage: action.payload,
        loading: false
      };
    default:
      return state;
  }
};

export default automaticDiscountsReducer;